import { Field } from "devextreme/ui/pivot_grid/data_source";

import { DataFormModel } from "../../../components/dataFormModel";

export const PostingDateFormMetaData: DataFormModel = {
  panels: [
    {
      caption: "",
      order: 1,
      columns: [
        {
          dataField: "jeExport.postingDate",
          editorType: "dxDateBox",
          label: "selectPostingDateFormPostingDate",
          editorOptions: { disabled: false },
        },
        {
          dataField: "jeExport.ignoreError",
          editorType: "dxCheckBox",
          label: "selectPostingDateFormIgnoreError",
          editorOptions: { disabled: false },
        }
      ],
    },
  ],
};

export const ReviewRawTransactionsTicketingPivotFields: Array<Field> = [
  {
    caption: "Transaction Type",
    width: 120,
    dataField: "transaction.typeName",
    area: "row",
  },
  {
    caption: "Fisical Year",
    width: 60,
    dataField: "campaign.fiscalYear",
    area: "row",
  },
  {
    caption: "Price Type",
    width: 120,
    dataField: "performance.priceType",
    area: "row",
  },
  {
    caption: "Performance Price Type GL No.",
    width: 160,
    dataField: "performance.priceTypeGlNo",
    area: "row",
  },
  {
    caption: "Performance Price Type GL Name",
    width: 160,
    dataField: "performance.priceTypeGlName",
    area: "row",
  },
  {
    caption: "Sign",
    width: 20,
    dataField: "transaction.amountSign",
    area: "row",
  },
  {
    caption: "Performance",
    width: 120,
    dataField: "performance.name",
    area: "column",
  },
  {
    caption: "Transaction Amount",
    width: 120,
    dataField: "transaction.amount",
    dataType: "number",
    summaryType: "sum",
    area: "data",
  },
];
